import { get } from 'common/utils/request';
export var fetchSupportRequestTypesApi = function () {
    return get('/support-request-types?isArchived=false');
};
